/**
 * 荷兰语（nl）
 */

import nlLocale from 'element-ui/lib/locale/lang/nl'

export default {
  ...nlLocale,
  common: {},
  // 语言
  lang: {
    english: 'Engels',
    spanish: 'Spaans',
    japanese: 'Japans',
    portuguese: 'Portugees',
    french: 'Frans',
    russian: 'Russisch',
    arabic: 'Arabisch',
    german: 'Duits',
    italian: 'Italiaans',
    vietnam: 'Vietnam',
    turkey: 'Turkije',
    korean: 'Koreaans',
    thai: 'Thai.',
    dutch: 'Nederlands',
    hebrew: 'Hebreeuws',
    indonesian: 'Indonesisch'
  },

  // 苏子龙
  // 现货页面 inSrock
  inSrock: {}

  // 张丰

  // 孙泽严
}
